import "./ListGroupItem_module.css";
const ListGroupItem_module_rslib_entry_ = {
    ListGroupItem: "ListGroupItem-e5OSpU",
    listGroupItem: "ListGroupItem-e5OSpU",
    ListGroupItem__icon: "ListGroupItem__icon-dDZKRF",
    listGroupItemIcon: "ListGroupItem__icon-dDZKRF"
};
export { ListGroupItem_module_rslib_entry_ as default };

//# sourceMappingURL=ListGroupItem.module.js.map